import React from 'react';

const Meter = ({ stepCount, stepIndex }) => {
    return (
        <div className="clx-step__meter">
            {[...Array(stepCount)].map((_, idx) => (
                <span key={idx + 1} className={idx + 1 === stepIndex || idx + 1 < stepIndex ? 'active' : ''}></span>
            ))}
        </div>
    );
};

export default Meter;
